import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import BasicDialog from "../../base/BasicDialog";
import LoaderWrapper from "../../wrapper/LoaderWrapper";
import { useAsync, useAsyncFn } from "../../../hooks/useAsync";
import { useSnackbarAlert } from "../../../context/snackbarAlert";
import useFeedbackService from "../../../services/feedbackService";
import FeedbackForm from "../../form/FeedbackForm/FeedbackForm";
import Button from "@mui/material/Button";
import { useState } from "react";
import useDialog from "../../../hooks/useDialog";
import ConfirmationDialog from "../ConfirmationDialog/confirmationDialog";

import { OliviaLogo } from "../../../media/logo";

const FeedbackDialog = (props) => {
  const { t } = useTranslation();
  const snackbarAlert = useSnackbarAlert();

  const { sendFeedback, getRateSelectList } = useFeedbackService();
  const rateSelectList = useAsync(getRateSelectList);
  const sendFeedbackFn = useAsyncFn(sendFeedback);

  const handleSendFeedback = (rateId) => {
    sendFeedbackFn
      .execute({ ticket: props.ticketId, rate: rateId })
      .then(() => {})
      .catch(() => {
        snackbarAlert.openErrorSnackbarAlert(
          t("snackbar_alert.occurred_error_during_saving_changes"),
        );
      });
  };

  const [isFeedbackNoteFilled, setIsFeedbackNoteFilled] = useState(false);
  const [
    openConfirmationDialog,
    onOpenConfirmationDialog,
    onCloseConfirmationDialog,
  ] = useDialog();

  const handleClose = () => {
    if (isFeedbackNoteFilled) {
      onOpenConfirmationDialog();
    } else {
      props.onClose(sendFeedbackFn.value);
    }
  };

  const handleCloseConfirmationDialog = (confirmClose) => {
    onCloseConfirmationDialog();
    if (confirmClose) props.onClose(sendFeedbackFn.value);
  };

  return (
    <BasicDialog
      open={props.open}
      onClose={handleClose}
      titleAlign="center"
      contentAlign="center"
      title={t("dialog.feedback.rate_ticket")}
      maxWidth="md"
      showDialogActions
    >
      <Grid item xs={12}>
        <img
          className=""
          src={OliviaLogo}
          alt=""
          height={80}
          style={{ textAlign: "left" }}
        />
      </Grid>
      <LoaderWrapper showLoader={rateSelectList.loading}>
        <>
          <Typography
            style={{ color: "var(--primary)" }}
            variant="h6"
            display="block"
            gutterBottom
          >
            {t("dialog.feedback.rate_ticket_realisation")}
          </Typography>
          <Grid container justifyContent={"center"}>
            {rateSelectList.value &&
              rateSelectList.value.map((rate) => (
                <Button
                  style={{
                    paddingBlock: "10px",
                    margin: "8px",
                    fontSize: "15px",
                  }}
                  variant={
                    sendFeedbackFn.value?.rate == rate.id
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() =>
                    sendFeedbackFn.value ? null : handleSendFeedback(rate.id)
                  }
                >
                  {rate.rate_name}
                </Button>
              ))}
          </Grid>
        </>
      </LoaderWrapper>
      <LoaderWrapper showLoader={sendFeedbackFn.loading}>
        <Grid container justifyContent={"center"} alignItems={"center"}>
          <Grid item xs={12}>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="center"
            >
              {sendFeedbackFn.value && (
                <FeedbackForm
                  feedbackId={sendFeedbackFn.value && sendFeedbackFn.value.id}
                  ticketId={props.ticketId}
                  style={{ padding: "10px" }}
                  showLogo={false}
                  showPaper={false}
                  setIsFeedbackNoteFilled={setIsFeedbackNoteFilled}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </LoaderWrapper>
      {openConfirmationDialog && (
        <ConfirmationDialog
          open={openConfirmationDialog}
          onNo={() => handleCloseConfirmationDialog(false)}
          onYes={() => handleCloseConfirmationDialog(true)}
          title={t("dialog.feedback.alert")}
          content={t(
            "dialog.feedback.are_you_sure_to_close_dialog_without_send_note",
          )}
          btnYesColor={"error"}
          btnNoColor={"primary"}
        />
      )}
    </BasicDialog>
  );
};

FeedbackDialog.propTypes = {
  ticketId: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

FeedbackDialog.defaultProps = {
  open: false,
};

export default FeedbackDialog;
